export default __webpack_public_path__ + "static/media/shopping-bag.3b4aadc3.svg";